module.exports = __webpack_public_path__ + "img/start-bg.cfc5fa70.png";